import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators';
import {
  containerStyles,
  normalizeStyles,
  typographyStyles,
} from "@webs/components-library/theming";

@customElement('webs-quick-link')
export class QuickLink extends LitElement {

  static styles = [
    normalizeStyles,
    containerStyles,
    typographyStyles,
    css`
      .m-quick-link .button {
        align-items: center;
        cursor: pointer;
        display: inline-flex;
        font: var(--font-weight-strong) .8rem/1.3 var(--font-family-alternative);
        justify-content: center;
        outline: none;
        overflow: hidden;
        padding: .65rem 1.5rem;
        position: relative;
        text-decoration: none;
        transition: background .1s linear, border .1s linear, color .1s linear;
        z-index: 1;


        background: transparent;
        border: 1.5px solid var(--color-primary);
        border-radius: 2.5rem;
        display: inline-block;
        color: var(--color-base);
        font-weight: var(--font-weight-base);
        padding: 1rem 3.5rem 1rem 1rem;
        position: relative;
        vertical-align: middle;
      }
      .m-quick-link .button::after {
        background: var(--icon-chevron-right-white) center/6.5px 13px no-repeat, var(--color-base);
        border-radius: 50%;
        content: '';
        display: inline-block;
        height: 40px;
        right: 1rem;
        padding: .8rem 1rem;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        transition: background .2s linear;
        vertical-align: middle;
        width: 40px;
        margin-left: 2rem;
      }

      .m-quick-link .button:hover {
        color: var(--color-primary);
      }
      .m-quick-link .button {
        padding: 1rem 5rem 1rem 1.5rem;
      }

      @media only screen and (max-width: 768px) {
        .m-quick-link .button {
          width: 100% !important;
        }
      }
    `
  ]

  @property()
  href: string;

  @property()
  width = "100%";

  protected render(): unknown {
    return html`
    <div class="m-quick-link">
      <a style="width:${this.width}" href="${this.href}" class="button"><slot></slot></a>
    </div>
    `
  }
}
